import { Alert } from "components/commons/alert"
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { getAllQueryParams, setQueryParams } from 'utils/utils'
import { API_TAX_PLANNING_SETTING } from 'services/apiTaxPlanningSetting'
import { useFetch } from 'services/useFetch'
import { DEFAULT_QUERY, OPTION_BULK, TABLE_TAX_PLANNING_LIST } from "configs/payroll/configTableTaxPlanningSetting"
import { TaxPlanningSetting } from "components/payroll/tax-planning-setting/TaxPlanningSetting"

export const TaxPlanningSettingContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : DEFAULT_QUERY
    const [selectedEmployeeList, setSelectedEmployeeList] = useState([])
    const [selectedBulkOption, setSelectedBulkOption] = useState()
    const [toastMessage, setToastMessage] = useState('')
    const [modal, setModal] = useState({
        limit: false,
        toast: false,
        bulk_update: false,
    })
    const {
        data: employeeList,
        fetching: getEmployeeList,
        isLoading,
    } = useFetch(API_TAX_PLANNING_SETTING.EMPLOYEE_LIST, DEFAULT_QUERY)
    const { fetching: bulkUpdateStatus } = useFetch(API_TAX_PLANNING_SETTING.BULK_UPDATE_STATUS)

    useEffect(() => {
        fetchEmployeeList({ ...query })
    }, [location.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchEmployeeList = (item = query) => {
        getEmployeeList(item)
    }

    const onBulkUpdate = (option) => {
        if (selectedEmployeeList.length === 0) {
            return Alert({
                icon: 'warning',
                title: 'Silakan pilih employee terlebih dahulu.',
                autoClose: true,
            })
        }

        setSelectedBulkOption(option)
        setModal({ ...modal, bulk_update: true })
    }

    const onUpdateStatus = () => {
        const bodyRequest = {
            employee_ids: selectedEmployeeList.map((item) => item.id),
            tax_planning_status: selectedBulkOption === OPTION_BULK?.ACTIVE ? true : false,
        }

        bulkUpdateStatus(bodyRequest)
            .then(() => {
                setToastMessage(`Tax Planning ${selectedBulkOption === OPTION_BULK?.ACTIVE ? 'Activated !!' : 'Deactivated !!'}`)
                setModal({ ...modal, bulk_update: false, toast: true })
                fetchEmployeeList()
            })
            .catch((err) => {
                setModal({ ...modal, bulk_update: false })
            })
    }

    const props = {
        dataEmployee: employeeList?.data,
        optionBulk: OPTION_BULK,
        configTable: TABLE_TAX_PLANNING_LIST,
        selectedEmployeeList,
        selectedBulkOption,
        isLoading,
        query,
        modal,
        toastMessage,
        onChangeQuery,
        onSelectItem: (employeeList) => setSelectedEmployeeList([...employeeList]),
        onBulkUpdate,
        onSetModal: (e) => setModal({ ...modal, ...e }),
        onUpdateStatus,
    }

    return <TaxPlanningSetting {...props}/>
}
